export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["प्रगति में"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["पूर्ण"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["प्रतीक्षारत"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["अगला"])}
}